class FeaturedProductDrop {

  constructor(settings) {
    let flag, timer, textFlag;

    this.options = Object.assign({
      container: 'header',
      onClickOutside: true,
      menuActiveClass: 'nav-active',
      menuOpener: '.nav-opener',
      menuDrop: '.nav-drop',
      dropLabels: 'label',
      toggleEvent: 'click',
      outsideClickEvent: 'click touchstart pointerdown MSPointerDown'.split(' '),
      resizeClass: 'resize',
      breakpoint: 768
    }, settings)

    //if isset opener and container elements
    if (document.querySelector(this.options.menuOpener) && document.querySelector(this.options.container)) {
      this.page = document.querySelector('html');
      this.container = this.page.querySelector(this.options.container);
      this.opener = this.container.querySelector(this.options.menuOpener);
      this.drop = this.container.querySelector(this.options.menuDrop);
      this.dropLabels = this.container.querySelectorAll(this.options.dropLabels);
      this.calculationButton = this.page.querySelector('.calculation-button');

      this._attachEvents();

      this.dropLabels.forEach(label => {
        label.addEventListener(this.options.toggleEvent, this._updateLabel.bind(this));
      });

    }
  }

  _attachEvents() {
    if (this._activateResizeHandler) {
      this._activateResizeHandler();
      this._activateResizeHandler = null;
    }

    this.opener.addEventListener(this.options.toggleEvent, this._openerClickHandler.bind(this));
  }

  _outsideClickHandler(e) {
    if (this._isOpened()) {
      if (!e.target.closest(this.options.menuOpener) && !e.target.closest(this.options.menuDrop)) {
        this._hide();
      }
    }
  }

  _updateLabel(e) {
    const labelText = e.target.textContent;
    this.opener_span = this.opener.querySelector('span');
    this.opener_span.textContent = labelText;
    this.calculationButton.classList.add('feature-product-ready');
    this._checkButton();
    this._hide();
  }

  _checkButton() {
    if(this.calculationButton.classList.contains('ready')) {
      this.calculationButton.removeAttribute("disabled");
    } else {
      this.calculationButton.setAttribute("disabled", true);
    }
  }

  _openerClickHandler(e) {
    e.preventDefault();
    this._toggle();
  }

  _isOpened() {
    return this.container.classList.contains(this.options.menuActiveClass);
  }

  _show() {
    this.container.classList.add(this.options.menuActiveClass);
    if (this.options.onClickOutside) {
      this.options.outsideClickEvent.forEach((e) => {
          document.addEventListener(e, this._outsideClickHandler.bind(this));
        }
      )
    }
  }

  _hide() {
    this.container.classList.remove(this.options.menuActiveClass)
    if (this.options.onClickOutside) {
      this.options.outsideClickEvent.forEach((e) => {
          document.removeEventListener(e, this._outsideClickHandler.bind(this));
        }
      )
    }
  }

  _toggle() {
    if (this._isOpened()) {
      this._hide();
    } else {
      this._show();
    }
  }

  _activateResizeHandler() {
    this._removeClassHandler();
    window.addEventListener('resize', this._resizeHandler.bind(this));
  }

  _removeClassHandler() {
    this.flag = false;
    this.page.classList.remove(this.options.resizeClass);
  }

  _resizeHandler() {
    if (!this.flag) {
      this.flag = true;
      this.page.classList.add(this.options.resizeClass);
    }
    if (window.innerWidth > this.options.breakpoint && this._isOpened()) {
      this._hide();
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(this._removeClassHandler.bind(this), 500);
  }
}

const burgerMenu = new FeaturedProductDrop({
  container: '.product-form__drop-wrap',
  menuActiveClass: 'drop-active',
  menuOpener: '.product-form__drop-opener',
  menuDrop: '.product-form__drop-input',
});

const filterDrop = new FeaturedProductDrop({
  container: '.more-filters',
  onClickOutside: false,
  menuActiveClass: 'filters-active',
  menuOpener: '.more-filters__opener',
  menuDrop: '.more-filters__holder',
});
